import {
  type BreadcrumbItemProps,
  Breadcrumbs as BreadcrumbsUi,
} from '@gyym/ui'

import { BreadcrumbsContainer } from './styles'

export interface BreadcrumbsProps {
  breadcrumbs?: {
    label: string
    href: BreadcrumbItemProps['href']
    as?: BreadcrumbItemProps['as']
  }[]
  pcOnly?: boolean
  bleed?: boolean
}

export const Breadcrumbs = ({
  breadcrumbs = [],
  pcOnly = false,
  bleed = false,
}: BreadcrumbsProps) => (
  <BreadcrumbsContainer pcOnly={pcOnly} bleed={bleed}>
    <BreadcrumbsUi>
      {breadcrumbs.map((breadcrumb, i) => (
        <BreadcrumbsUi.Item key={i} href={breadcrumb.href} as={breadcrumb.as}>
          {breadcrumb.label}
        </BreadcrumbsUi.Item>
      ))}
    </BreadcrumbsUi>
  </BreadcrumbsContainer>
)
